import { useQuery } from '@tanstack/react-query';
import { fetchCountries } from '../../../api/administration/demographics/countryDefinitions';

export const useCountries = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['countries', filters],
    queryFn: () => fetchCountries(filters),
    keepPreviousData: true,
    enabled: options.enabled,
  });
  console.log('useCountries - query data:', query.data);

  return {
    ...query,
    data: query.data?.data?.countries ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useCountries;
